import axios from 'axios'
import Vue from 'vue'
import { Toast } from 'vant'

const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000',
  timeout: 30000
})

http.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    console.log('请求拦截器 - URL:', config.url)
    console.log('请求拦截器 - Token:', token)
    if (token) {
      config.headers['Token'] = token
      console.log('请求拦截器 - 已设置Token header')
    } else {
      console.log('请求拦截器 - Token为空，未设置header')
    }
    console.log('请求拦截器 - 最终headers:', config.headers)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 401) {
      Toast.fail('登录已过期，请重新登录')
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      window.location.href = '#/login'
      return Promise.reject(new Error('登录已过期'))
    }
    if (res.code === 403) {
      Toast.fail('需要VIP才能继续答题')
      return Promise.reject(new Error('需要VIP'))
    }
    if (res.code !== 200) {
      Toast.fail(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return response
  },
  error => {
    Toast.fail(error.message || '网络错误')
    return Promise.reject(error)
  }
)

Vue.prototype.$http = http

export default http